import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { StackOutput } from "types/generated";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";

type OutputWithStack = StackOutput & {
  stackId: string;
  stackName: string;
};

const TemplateDeploymentOutputsValueCell = ({
  item: output,
  ...cellProps
}: TableSimpleCellProps<OutputWithStack>) => {
  const displayValue = output.sensitive ? "••••••••" : output.value || "-";

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{displayValue}</TableCellText>
    </TableSimpleCell>
  );
};

export default TemplateDeploymentOutputsValueCell;
